import type { ObjectMetadata } from '@olytic/foundation';

import { formatNumber } from '../../objects/format';
import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asLabel, createdByField, field, lastModifiedByField, lookup, type Row, show, text } from './kit';

const def = OBJECT_DEFS['billing-treatment-items'];
const number = show((v) => formatNumber(v));

/** One milestone or installment in a treatment. Rationale: billing-treatment-items.md. */
export const billingTreatmentItems: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Treatment item',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('label', 'Label'),
    field('billing_treatment_name', 'Billing Treatment', { link: lookup('billing-treatments', 'billing_treatment_id') }),
    field('percent', 'Percent', { format: show((v) => `${formatNumber(v)}%`) }),
    field('trigger', 'Billed', { format: asLabel }),
    field('month_offset', 'Months After Kickoff', { format: number }),
    field('sequence', 'Order', { format: number }),
    createdByField(),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['label', 'billing_treatment_name', 'percent', 'trigger', 'month_offset', 'sequence'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_by_name', 'last_modified_by_name'] },
  ],
  related: [],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'billing_treatment_name'],
};
